import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight, Wallet, ShieldCheck } from 'lucide-react';

export default function Home() {
    return (
        <div className="flex flex-col items-center justify-center min-h-[80vh] text-center space-y-12 animate-in fade-in duration-1000">

            {/* Hero Section */}
            <div className="space-y-6 max-w-4xl mx-auto">
                <div className="inline-flex items-center space-x-2 bg-neutral-900/50 border border-neutral-800 rounded-full px-4 py-1.5 text-sm text-neutral-300 mb-4 ring-1 ring-white/10 shadow-lg glow">
                    <Sparkles className="w-4 h-4 text-purple-400" />
                    <span>The next generation of Pokémon Card trading.</span>
                </div>

                <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight">
                    Manage your inventory. <br />
                    <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 inline-block mt-2">
                        Showcase your collection.
                    </span>
                </h1>

                <p className="text-lg md:text-xl text-neutral-400 max-w-2xl mx-auto leading-relaxed">
                    Create dynamic storefronts, manage live prices, and export beautiful 3x3 binder pages instantly. All seamlessly connected to WhatsApp for effortless sales.
                </p>

                <div className="pt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Link
                        to="/register"
                        className="w-full sm:w-auto flex items-center justify-center space-x-2 bg-white text-black px-8 py-4 rounded-full font-semibold hover:bg-neutral-200 transition-all hover:scale-105 shadow-[0_0_40px_-10px_rgba(255,255,255,0.5)]"
                    >
                        <span>Start Selling Free</span>
                        <ArrowRight className="w-5 h-5" />
                    </Link>
                    <Link
                        to="/login"
                        className="w-full sm:w-auto flex items-center justify-center px-8 py-4 rounded-full font-semibold text-white bg-neutral-900 border border-neutral-800 hover:bg-neutral-800 transition-all"
                    >
                        Vendor Login
                    </Link>
                </div>
            </div>

            {/* Feature Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-6xl mt-16 text-left">
                {[
                    { icon: Wallet, title: "TCGDex Powered", desc: "Instant high-res card scans & metadata directly from the TCGDex open API." },
                    { icon: Sparkles, title: "Beautiful Storefronts", desc: "Share your own clean, responsive URL with potential buyers." },
                    { icon: ShieldCheck, title: "Frictionless Sales", desc: "Buyers build a cart directly from your page and finalize it via WhatsApp." }
                ].map((feature, i) => (
                    <div key={i} className="p-8 rounded-2xl bg-gradient-to-b from-neutral-900 to-neutral-950 border border-neutral-800 shadow-xl hover:-translate-y-1 transition-transform group">
                        <div className="w-12 h-12 bg-neutral-800 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                            <feature.icon className="w-6 h-6 text-purple-400" />
                        </div>
                        <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
                        <p className="text-neutral-400 leading-relaxed text-sm">{feature.desc}</p>
                    </div>
                ))}
            </div>

        </div>
    );
}
